import React from 'react'
import PropTypes from 'prop-types';
import { Button, Container } from 'react-bootstrap'

export const FAQ = (props, context) => {

    return (
        <Container fluid className="main-content-container px-4 pb-0">
            <div className="wiki">
                <div className="wiki__content">
                    <h3>FAQ </h3>
                    <p>frequently asked questions</p>
                    <Button onClick={e => { }}>&larr; {context.t('TBD')}</Button>
                </div>
            </div>
         </Container>
    )
}

FAQ.contextTypes = {
    t: PropTypes.func.isRequired
}
  
export default FAQ